import { IconButton, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { ApiPortfolioState } from '../../dashboard/models/ApiPortfolioState';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { CommentModel } from '../models/CommentModel';
import CommentService from '../../assessments/services/CommentService';
import DateService from '../../shared/services/DateService';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import DoneIcon from '@mui/icons-material/Done';
import Grid from '@mui/material/Unstable_Grid2';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import WithConfirmation from '../../shared/components/WithConfirmation';
import styles from '../styles/CommentComponent.module.css';
import { useLessonPlayerContext } from '../../dashboard/models/LessonPlayerContext';

interface CommentComponentProps {
  comment: CommentModel;
  marker: string;
  onEdit: (comment: CommentModel, updatedText: string) => void;
  onDelete: (comment: CommentModel) => void;
}

export default function CommentComponent(props: CommentComponentProps) {
  const { lessonState } = useLessonPlayerContext();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [updatedText, setUpdatedText] = useState(props.comment.assets.text);
  const [edit, setEdit] = useState(false);

  function handleClick(event: React.MouseEvent<HTMLButtonElement>) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  const marker = CommentService.getMarkername(props.comment);

  return (
    <>
      <Grid container direction="row">
        <Grid xs={11} container direction="column">
          <Paper className={styles.paper}>
            <Grid>
              <Typography className={styles.commentFont}>{marker}</Typography>
            </Grid>
            <Grid>
              <Typography className={styles.commentDate}>
                {DateService.formatDate(props.comment.created)}
              </Typography>
            </Grid>
            <Grid>
              {edit ? (
                <TextField
                  variant="outlined"
                  className={styles.input}
                  value={updatedText}
                  multiline
                  minRows={2}
                  onChange={(e) => setUpdatedText(e.target.value)}
                />
              ) : (
                <Typography variant="subtitle1" className={styles.commentText}>
                  {updatedText}
                </Typography>
              )}
            </Grid>
            {edit && (
              <Grid container justifyContent="flex-end">
                <IconButton
                  size="small"
                  onClick={() => {
                    setEdit(false);
                    setUpdatedText(props.comment.assets.text);
                  }}
                >
                  <CloseIcon />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={() => {
                    setEdit(false);
                    props.onEdit(props.comment, updatedText);
                  }}
                >
                  <DoneIcon />
                </IconButton>
              </Grid>
            )}
          </Paper>
        </Grid>
        <Grid container xs={1} alignItems="flex-start">
          {lessonState.state === ApiPortfolioState.AssessmentMark && (
            <IconButton size="small" onClick={handleClick}>
              <MoreVertIcon fontSize="small" />
            </IconButton>
          )}
          <Menu
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem
              onClick={() => {
                setEdit(true);
                setAnchorEl(null);
              }}
            >
              <Grid container direction="row" justifyContent="space-between">
                <Grid>
                  <Typography variant="caption" className={styles.capitalize}>
                    Edit Comment
                  </Typography>
                </Grid>
                <Grid>
                  <BorderColorOutlinedIcon fontSize="small" />
                </Grid>
              </Grid>
            </MenuItem>
            <MenuItem>
              <WithConfirmation onConfirm={() => props.onDelete(props.comment)}>
                <Grid container direction="row" justifyContent="space-between">
                  <Grid className={styles.deleteText}>
                    <Typography variant="caption" className={styles.capitalize}>
                      Delete Comment
                    </Typography>
                  </Grid>
                  <Grid className={styles.deleteIcon}>
                    <DeleteOutlineOutlinedIcon fontSize="small" />
                  </Grid>
                </Grid>
              </WithConfirmation>
            </MenuItem>
          </Menu>
        </Grid>
      </Grid>
    </>
  );
}
